import configs from '@/configs';
import { export_list, request_header } from '@/commons/hpod';
import { sendErrorNotice, sendSuccessNotice } from '@/commons/utils';
import Vue from 'vue';
var FileSaver = require('file-saver');
import Crud from './crud'
var crud = new Crud('export-receipt', 'phiếu xuất kho');

const state = {
    ...crud.state,
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    export_excel({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list('export-receipt', res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"});
            FileSaver.saveAs(blob, `DanhSachPhieuXuat.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export_excel');
    },
    payReceipt({ commit, rootState }, payload) {
        commit("setLoading", { loading: true });
        const header = {
            headers: request_header(rootState.authentication.token)
        };
        const receiptId = (typeof payload === 'object' && payload !== null) ? payload.receiptId : payload;
        const ignoreVatCheck = (typeof payload === 'object' && payload !== null && payload.ignore_vat_check) ? true : false;
        return Vue.http.post(`${configs.API}/admin/api/export-receipt/${receiptId}/payment/`, { ignore_vat_check: ignoreVatCheck }, header)
            .then(res => {
                sendSuccessNotice('Thanh toán phiếu xuất thành công.');
                return res.data;
            })
            .catch(error => {
                const resBody = (error.body && typeof error.body === 'object') ? error.body : ((error.data && typeof error.data === 'object') ? error.data : {});
                const reason = resBody.reason || error.message || 'Thanh toán phiếu xuất thất bại.';
                const isVatError = resBody.code === 'VAT_CONFIRM_REQUIRED' || (resBody.data && resBody.data.need_confirm_vat) || reason.includes('chưa có thông tin thuế VAT');
                if (isVatError) {
                    const customError = new Error(reason);
                    customError.need_confirm_vat = true;
                    customError.reason = reason;
                    throw customError;
                }
                sendErrorNotice(reason);
                throw error;
            })
            .finally(() => {
                commit("setLoading", { loading: false });
            });
    }
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
